import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import { useContent } from '@/stores/RootStore';
import SubPageHero from '@/components/SubPageHero';
import { CHAT_WIDGET } from '@/data/mockData';
import s from './Inquiry.module.scss';

/**
 * [2026-09-10 / 2026-09-11 실무화] 실시간 상담 — 고객지원 안내 페이지.
 *   ★로그인 게이트 제거(2026-09-11): 상담 '연락 수단' 안내는 비회원도 봐야 실무적으로 맞음.
 *     실제 채널로 연결 — 전화(company.tel)·카카오톡 채널(pf.kakao, footer와 동일)·1:1 문의(로그인)·FAQ.
 *   (실시간 채팅 백엔드 연동은 추후. 지금은 실제 연락 수단으로 안내.)
 */
const KAKAO_URL = 'http://pf.kakao.com/_xikTUn/chat';   // footer와 동일한 실제 카카오톡 채널

function Consult() {
	const nav = useNavigate();
	const { company } = useContent();
	const telDigits = String(company.tel || '').split(/[,/]/)[0].replace(/[^0-9]/g, '');   // 대표번호 첫 항목

	return (
		<>
			<SubPageHero title="실시간 상담" subtitle="제품 선택·견적·설치·체험 등 궁금한 점을 실시간 채팅으로 담당자와 바로 상담하세요."
				image="/images/auth/hero.jpg" crumbs={[{ label: 'HOME' }, { label: '고객지원' }, { label: '실시간 상담' }]} />
			<div className={s.wrap}>
				<div className={s.inner}>
					<p className={s.sectionLabel}>LIVE SUPPORT</p>
					<h2 className={s.h2}>{CHAT_WIDGET.greeting}</h2>
					<p className={s.lead}>{CHAT_WIDGET.awayNotice}</p>

					<div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
						{/* 전화 상담 — 대표번호 tel: 링크 */}
						<a href={`tel:${telDigits}`} style={optStyle}>
							<span style={optTitle}>전화 상담</span>
							<span style={optDesc}>대표번호 {company.tel} · 평일 09:00~18:00</span>
						</a>
						{/* 카카오톡 채널 — 실제 채널(새 탭) */}
						<a href={KAKAO_URL} target="_blank" rel="noopener noreferrer" style={optStyle}>
							<span style={optTitle}>카카오톡 채널 상담</span>
							<span style={optDesc}>카카오톡으로 실시간 문의 — EVS 채널로 연결됩니다.</span>
						</a>
						{/* 1:1 문의(로그인 필요) */}
						<button onClick={() => nav('/support/inquiry')} style={{ ...optStyle, cursor: 'pointer' }}>
							<span style={optTitle}>1:1 문의 남기기 <span style={lockBadge}>로그인 필요</span></span>
							<span style={optDesc}>제품·설치·견적·A/S 문의를 남기면 담당자가 답변드리고, 내 문의에서 답변을 확인합니다.</span>
						</button>
						{/* FAQ */}
						<button onClick={() => nav('/support/faq')} style={{ ...optStyle, cursor: 'pointer' }}>
							<span style={optTitle}>자주 묻는 질문(FAQ)</span>
							<span style={optDesc}>안전·환경 제품과 서비스에 대한 답변을 먼저 확인하세요.</span>
						</button>
					</div>
				</div>
			</div>
		</>
	);
}

const optStyle: React.CSSProperties = { display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 5, textAlign: 'left', padding: '20px 22px', background: '#fff', border: '1.5px solid #e5eaf0', borderRadius: 12, textDecoration: 'none' };
const optTitle: React.CSSProperties = { fontSize: 16, fontWeight: 700, color: '#222833', display: 'flex', alignItems: 'center', gap: 8 };
const optDesc: React.CSSProperties = { fontSize: 13.5, color: '#8299ab' };
const lockBadge: React.CSSProperties = { fontSize: 11, fontWeight: 700, color: '#0f8fc4', background: 'rgba(31,178,238,.12)', borderRadius: 20, padding: '2px 8px' };

export default observer(Consult);
